import React, { useEffect, useRef } from "react";
import { KLineChartPro } from "@klinecharts/pro";
import "@klinecharts/pro/dist/klinecharts-pro.css";
import { useCompanyHistoricalData } from "data/company";

// 👇 OUTSIDE COMPONENT
function aggregateWeekly(data) {
  const grouped = {};

  data.forEach(item => {
    const date = new Date(item.timestamp);

    const year = date.getFullYear();

    const week = Math.ceil(
      ((date - new Date(year, 0, 1)) / 86400000 +
        new Date(year, 0, 1).getDay() +
        1) / 7
    );

    const key = `${year}-${week}`;

    if (!grouped[key]) {
      grouped[key] = {
        timestamp: item.timestamp,
        open: item.open,
        high: item.high,
        low: item.low,
        close: item.close,
        volume: item.volume
      };
    } else {
      grouped[key].high = Math.max(
        grouped[key].high,
        item.high
      );

      grouped[key].low = Math.min(
        grouped[key].low,
        item.low
      );

      grouped[key].close = item.close;

      grouped[key].volume += item.volume;
    }
  });

  return Object.values(grouped);
}

/** monthly function  */

function aggregateMonthly(data) {
  const grouped = {};

  data.forEach(item => {
    const date = new Date(item.timestamp);

    const year = date.getFullYear();

    // month: 0-11
    const month = date.getMonth() + 1;

    const key = `${year}-${month}`;

    if (!grouped[key]) {
      grouped[key] = {
        timestamp: item.timestamp,
        open: item.open,
        high: item.high,
        low: item.low,
        close: item.close,
        volume: item.volume
      };
    } else {

      // highest high
      grouped[key].high = Math.max(
        grouped[key].high,
        item.high
      );

      // lowest low
      grouped[key].low = Math.min(
        grouped[key].low,
        item.low
      );

      // latest close
      grouped[key].close = item.close;

      // total volume
      grouped[key].volume += item.volume;
    }
  });

  return Object.values(grouped);
}


export default function KLineChartProC({ companyinfo }) {
  const containerRef = useRef(null);
  const chartRef = useRef(null);
 const { historicaldata, isLoading } =
    useCompanyHistoricalData(companyinfo?.id);
    
  useEffect(() => {
    if (!containerRef.current) return;
    if (isLoading) return;
    if (!historicaldata) return;

    const rawData = historicaldata || [];

    if (
      !Array.isArray(rawData) ||
      rawData.length === 0
    ) {
      return;
    }

    const formatted = rawData
  .sort(
    (a, b) =>
      new Date(a.trade_date) -
      new Date(b.trade_date)
  )
  .map(item => ({
    timestamp: Number(
      new Date(item.trade_date).getTime()
    ),

    open: Number(item.open_price),

    high: Number(item.high_price),

    low: Number(item.low_price),

    close: Number(item.close_price),

    volume: Number(item.volume)
  }))
  .filter(
    item =>
      !isNaN(item.timestamp) &&
      !isNaN(item.open) &&
      !isNaN(item.high) &&
      !isNaN(item.low) &&
      !isNaN(item.close) &&
      !isNaN(item.volume)
  );

    const chartInstance = new KLineChartPro({
      container: containerRef.current,
      drawingBarVisible: true,
      features: {
      symbolSearch: false
    },
    styles: {
    actionBar: {
      timezone: {
        display: false,
      },
    },
  },
      locale: "en-US",

      theme: "light",

      timezone: "Asia/Kolkata",

      symbol: {
        ticker: companyinfo?.symbol,
        shortName: companyinfo?.symbol,
        exchange: "NSE",
        market: "stocks",
        priceCurrency: "INR",
        type: "stock",
        name: companyinfo?.symbol,
      },

      period: {
        multiplier: 1,
        timespan: "day",
        text: "1D"
      },
periods: [
  {
    multiplier: 1,
    timespan: "day",
    text: "1D"
  },
  {
    multiplier: 1,
    timespan: "week",
    text: "1W"
  },
  {
    multiplier: 1,
    timespan: "month",
    text: "1M"
  }
],

      mainIndicators: ["MA"],
      subIndicators: ["VOL", "RSI"],

      datafeed: {
        searchSymbols: async () => [],
getHistoryKLineData: async (
  symbol,
  period,
  from,
  to
) => {
  
  let data = formatted;

  if (period.timespan === "week") {
    data = aggregateWeekly(formatted);
  }

  if (period.timespan === "month") {
    data = aggregateMonthly(formatted);
  }

  // IMPORTANT: filter by range
  return data.filter(item => {
    return (
      item.timestamp >= from &&
      item.timestamp <= to
    );
  });
   
},

        subscribe: () => {},

        unsubscribe: () => {}
      }
    });
    
    chartRef.current = chartInstance;
    
setTimeout(() => {
if (!chartInstance) return;
  chartRef.current?.setSymbol({
    ticker: companyinfo?.symbol,
    shortName: companyinfo?.symbol,
    exchange: "NSE",
    market: "stocks",
    priceCurrency: "INR",
    type: "stock",
    name: companyinfo?.symbol,
  });
  const innerChart = chartInstance.getChart?.();
      if (innerChart) {
        // 👇 FIX: Use overrideIndicator directly without specifying a pane ID string.
        // The core library automatically matches the indicator name globally across all open panes.
        innerChart.overrideIndicator?.({
          name: "MA",
          calcParams: [10, 50]
        });
      }
      
}, 500);
    return () => {
      chartRef.current?.dispose?.();
    };
  }, [historicaldata, isLoading,companyinfo?.symbol]);


useEffect(() => {

  const timer = setTimeout(() => {

    const toolItems = document.querySelectorAll(
      '.klinecharts-pro-period-bar .item.tools'
    )

    toolItems.forEach((item) => {

      const span = item.querySelector('span')

      if (span?.innerText === 'Timezone') {
        item.style.display = 'none'
      }

    })

  }, 300)

  return () => clearTimeout(timer)

}, [])

  return (
  <div
   className="chart-scroll-wrapper"
    style={{
      width: "100%",
      overflowX: "auto",
      overflowY: "hidden",
      WebkitOverflowScrolling: "touch"
    }}
  >
    <div
      ref={containerRef}
      style={{
        width:
          window.innerWidth < 768
            ? "900px"
            : "100%",

        minWidth: "100%",

        height:
          window.innerWidth < 768
            ? "500px"
            : "700px",

        borderRadius: "16px",

        overflow: "hidden",

        background: "#fff",

        border: "1px solid #e2e8f0"
      }}
    />
  </div>
);
}
